import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getMediaList, MediaListItem } from '../../api/media';
import { getRegisterChannel, RegisterChannelOption } from '../../api/porters';
import type { RootState } from '../store';
import type { AsyncStatus } from '../../interfaces';

interface MasterState {
  mediaListStatus: AsyncStatus;
  mediaList: MediaListItem[];
  registerChannelStatus: AsyncStatus;
  registerChannel: RegisterChannelOption[];
}

const initialState: MasterState = {
  mediaListStatus: 'idle',
  mediaList: [],
  registerChannelStatus: 'idle',
  registerChannel: [],
};

export const fetchMediaList = createAsyncThunk('master/fetchMediaList', () => getMediaList(), {
  condition: (_, { getState }) => (getState() as RootState).master.mediaListStatus === 'idle',
});

export const fetchRegisterChannel = createAsyncThunk(
  'master/fetchRegisterChannel',
  () => getRegisterChannel(),
  {
    condition: (_, { getState }) =>
      (getState() as RootState).master.registerChannelStatus === 'idle',
  },
);

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMediaList.pending, (state) => {
        state.mediaListStatus = 'loading';
      })
      .addCase(fetchMediaList.fulfilled, (state, action) => {
        state.mediaListStatus = 'succeeded';
        state.mediaList = action.payload;
      })
      .addCase(fetchMediaList.rejected, (state) => {
        state.mediaListStatus = 'failed';
      })
      .addCase(fetchRegisterChannel.pending, (state) => {
        state.registerChannelStatus = 'loading';
      })
      .addCase(fetchRegisterChannel.fulfilled, (state, action) => {
        state.registerChannelStatus = 'succeeded';
        state.registerChannel = action.payload;
      })
      .addCase(fetchRegisterChannel.rejected, (state) => {
        state.registerChannelStatus = 'failed';
      });
  },
});

export default masterSlice.reducer;
